import { Sun, Moon } from 'lucide-react';
import { useProjectStore } from '../../store/projectStore';

export function ThemeToggle() {
  const darkMode = useProjectStore((state) => state.config.design.darkMode);
  const setConfig = useProjectStore((state) => state.setConfig);

  return (
    <button
      type="button"
      onClick={() =>
        setConfig({
          design: { ...useProjectStore.getState().config.design, darkMode: !darkMode },
        })
      }
      className="flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg border border-slate-300 dark:border-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
    >
      {darkMode ? <Moon size={16} /> : <Sun size={16} />}
      <span className="hidden sm:inline">{darkMode ? '深色' : '淺色'}</span>
    </button>
  );
}
